export class PlanCodeFilter  {

    readonly CODE_TYPE_BENEFIT : string = "1*";
    readonly CODE_TYPE_CONTRIBUTION : string = "2*";
    readonly CODE_TYPE_PENSION: string = "3*";
    readonly CODE_TYPE_WELFARE: string = "4*";
    readonly CODE_1A : string = "1A";
    readonly CODE_1B : string = "1B";
    readonly CODE_1C : string = "1C";
    readonly CODE_1D : string = "1D";
    readonly CODE_1E : string = "1E";
    readonly CODE_1F : string = "1F";
    readonly CODE_1G : string = "1G";
    readonly CODE_1H : string = "1H";
    readonly CODE_1I : string = "1I";
    readonly CODE_1J : string = "1J";
    readonly CODE_1K : string = "1K";
    readonly CODE_1L : string = "1L";
    readonly CODE_2A : string = "2A";
    readonly CODE_2B : string = "2B";
    readonly CODE_2C : string = "2C";
    readonly CODE_2D : string = "2D";
    readonly CODE_2E : string = "2E";
    readonly CODE_2F : string = "2F";
    readonly CODE_2G : string = "2G";
    readonly CODE_2H : string = "2H";
    readonly CODE_2I : string = "2I";
    readonly CODE_2J : string = "2J";
    readonly CODE_2K : string = "2K";
    readonly CODE_2L : string = "2L";
    readonly CODE_2M : string = "2M";
    readonly CODE_2N : string = "2N";
    readonly CODE_2O : string = "2O";
    readonly CODE_2P : string = "2P";
    readonly CODE_2Q : string = "2Q";
    readonly CODE_2R : string = "2R";
    readonly CODE_2S : string = "2S";
    readonly CODE_2T : string = "2T";
    readonly CODE_2U : string = "2U";
    readonly CODE_2V : string = "2V";
    readonly CODE_2W : string = "2W";
    readonly CODE_2X : string = "2X";
    readonly CODE_2Y : string = "2Y";
    readonly CODE_3B : string = "3B";
    readonly CODE_3C : string = "3C";
    readonly CODE_3D : string = "3D";
    readonly CODE_3F : string = "3F";
    readonly CODE_3H : string = "3H";
    readonly CODE_3I : string = "3I";
    readonly CODE_3J : string = "3J";
    readonly CODE_4A : string = "4A";
    readonly CODE_4B : string = "4B";
    readonly CODE_4C : string = "4C";
    readonly CODE_4D : string = "4D";
    readonly CODE_4E : string = "4E";
    readonly CODE_4F : string = "4F";
    readonly CODE_4G : string = "4G";
    readonly CODE_4H : string = "4H";
    readonly CODE_4I : string = "4I";
    readonly CODE_4J : string = "4J";
    readonly CODE_4K : string = "4K";
    readonly CODE_4L : string = "4L";
    readonly CODE_4P : string = "4P";
    readonly CODE_4Q : string = "4Q";
    readonly CODE_4R : string = "4R";
    readonly CODE_4S : string = "4S";
    readonly CODE_4T : string = "4T";
    readonly CODE_4U : string = "4U";

}